export function CountdownTimer({ time }) {
  return (
    <div
      style={{
        background: "linear-gradient(135deg, rgba(180, 83, 9, 0.3) 0%, rgba(159, 18, 57, 0.3) 100%)",
        border: "1px solid rgba(237, 144, 13, 0.3)",
        borderRadius: "0.5rem",
        padding: "2rem",
      }}
    >
      <h3 className="text-center mb-4" style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#fef3c7" }}>
        LA PREVENTA INICIA EN
      </h3>

      <div className="row g-3">
        <div className="col-6 col-md-3">
          <div className="countdown-box">
            <div className="countdown-number">{String(time.days).padStart(2, "0")}</div>
            <div className="countdown-label">Días</div>
          </div>
        </div>

        <div className="col-6 col-md-3">
          <div className="countdown-box">
            <div className="countdown-number">{String(time.hours).padStart(2, "0")}</div>
            <div className="countdown-label">Horas</div>
          </div>
        </div>

        <div className="col-6 col-md-3">
          <div className="countdown-box">
            <div className="countdown-number">{String(time.minutes).padStart(2, "0")}</div>
            <div className="countdown-label">Minutos</div>
          </div>
        </div>

        <div className="col-6 col-md-3">
          <div className="countdown-box">
            <div className="countdown-number">{String(time.seconds).padStart(2, "0")}</div>
            <div className="countdown-label">Segundos</div>
          </div>
        </div>
      </div>
    </div>
  )
}
